export enum PromptTypesEnum {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  AGENT = 'AGENT',
  SYSTEM_PROMPT = 'SYSTEM_PROMPT',
}

export enum PromptTypesFormattedEnum {
  IMAGE = 'Imagem',
  VIDEO = 'Vídeo',
  AGENT = 'Agente IA',
  SYSTEM_PROMPT = 'Vibe Code',
}
